import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=108f7372&scoped=true"
import script from "./prize.vue?vue&type=script&lang=ts"
export * from "./prize.vue?vue&type=script&lang=ts"
import style0 from "./prize.vue?vue&type=style&index=0&id=108f7372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f7372",
  null
  
)

export default component.exports